// src/context/PermissionContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';

const PermissionContext = createContext({
  menuPermissions: {},      // { "Dashboard": {view:true, ...}, ... }
  can: (menu, action) => false,
});

export const PermissionProvider = ({ children }) => {
  const [menuPermissions, setMenuPermissions] = useState({});

  // --------------------------------------------------------------
  // Load permissions from localStorage on first render
  // --------------------------------------------------------------
  useEffect(() => {
    const stored = localStorage.getItem('menuPermissions');
    if (stored) {
      try {
        setMenuPermissions(JSON.parse(stored));
      } catch (e) {
        console.warn('Failed to parse stored menuPermissions', e);
      }
    }
  }, []);

  // --------------------------------------------------------------
  // Helper – true if the user has the given action on the menu
  // --------------------------------------------------------------
  const can = (menuLabel, action) => {
    const role = (localStorage.getItem('role') || '').toLowerCase();

    // Customer Dashboard menu item is ONLY for customer logins
    if (menuLabel === 'Customer Dashboard' && role !== 'customer') {
      return false;
    }

    if (role.includes('super admin') || role.includes('superadmin') || role === 'admin') {
      return true;
    }

    if (!menuPermissions || Object.keys(menuPermissions).length === 0) {
      return true;
    }

    if (menuPermissions[menuLabel]) {
      return !!menuPermissions[menuLabel]?.[action];
    }

    if (menuLabel === 'Route Master' && menuPermissions['Route']) {
      return !!menuPermissions['Route']?.[action];
    }
    if (menuLabel === 'Route' && menuPermissions['Route Master']) {
      return !!menuPermissions['Route Master']?.[action];
    }
    if (menuLabel === 'Tracking No' && menuPermissions['Tracking Page']) {
      return !!menuPermissions['Tracking Page']?.[action];
    }
    if (menuLabel === 'Tracking Page' && menuPermissions['Tracking No']) {
      return !!menuPermissions['Tracking No']?.[action];
    }

    return false;
  };

  return (
    <PermissionContext.Provider value={{ menuPermissions, can, setMenuPermissions }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);